export enum EmploymentType {
  BULGARIAN_EMPLOYEE = 'BULGARIAN_EMPLOYEE',
  DREAMIX_WORLDWIDE = 'DREAMIX_WORLDWIDE',
  CONTRACTOR = 'CONTRACTOR',
}
